import { EntityPresenterV2Mode, isStaticMode } from './presenterV2EntityMode';

import type { Maybe } from '@nova/core';
import type { PresenterPlaceholderData } from './presenterV2Placeholder';
import type { YardAreaDetails } from './yardAreaPresenterV2Shared';

export function nestedAreaPresenterDataProps(
  mode: EntityPresenterV2Mode,
  data: {
    area?: Maybe<YardAreaDetails | PresenterPlaceholderData<YardAreaDetails>>;
  }
) {
  if (isStaticMode(mode)) {
    return {
      staticAreaData: (data.area ?? null) as Maybe<YardAreaDetails>
    };
  }

  return {
    placeholderAreaData: (data.area ?? null) as Maybe<PresenterPlaceholderData<YardAreaDetails>>
  };
}
